"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstructionalStep = void 0;
var InstructionalStep;
(function (InstructionalStep) {
    InstructionalStep[InstructionalStep["Connecting"] = 1] = "Connecting";
    InstructionalStep[InstructionalStep["Membership"] = 2] = "Membership";
    InstructionalStep[InstructionalStep["Payment"] = 3] = "Payment";
    InstructionalStep[InstructionalStep["Preparing"] = 4] = "Preparing";
})(InstructionalStep = exports.InstructionalStep || (exports.InstructionalStep = {}));
